import { observer } from 'mobx-react'

import type PlanningVersion from 'modules/time_planning/store/models/PlanningVersion'

import BasicInformation from './BasicInformation'

export interface Props {
  employeeId: number
  planningVersion: PlanningVersion
  canAssignEmployees: boolean
  canEditPlanningVersions: boolean
  canManageCompanySchedules: boolean
  canEditShifts: boolean
  canEditContracts: boolean
}

const Content = ({
  employeeId,
  planningVersion,
  canAssignEmployees,
  canEditPlanningVersions,
  canManageCompanySchedules,
  canEditShifts,
  canEditContracts,
}: Props) => {
  const editable = canEditPlanningVersions && !planningVersion.isDefault

  return (
    <BasicInformation
      employeeId={employeeId}
      planningVersion={planningVersion}
      canEdit={editable}
      canAssignEmployees={canAssignEmployees}
      canManageCompanySchedules={canManageCompanySchedules}
      canEditShifts={canEditShifts}
      canEditContracts={canEditContracts}
    />
  )
}

export default observer(Content)
